module.exports = __webpack_public_path__ + "static/media/sterling-and-wilson.ac9d52b5.png";